// extracted by mini-css-extract-plugin
export var activityContainer = "_m2-0";
export var typingIndicatorContainer = "_m2-1";
export var typingIndicatorDot = "_m2-2";
export var wave = "_m2-3";